// ENG2-2455 (T4, Part B): confirmation shown when an admin moves a customer
// onto one of the 2026 packages. See apply-package-defaults.ts for what
// "Apply defaults" sends.

import * as React from 'react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material'
import { planLabel } from 'utils/plan-label'
import { packageDefaultsNote } from './apply-package-defaults'

type Props = {
  open: boolean
  plan: string
  isSaving: boolean
  onApply: () => void
  onJustChange: () => void
  onCancel: () => void
}

function ApplyDefaultsDialog({
  open,
  plan,
  isSaving,
  onApply,
  onJustChange,
  onCancel,
}: Props) {
  // ENG2-2614: what RisikaAPI fills in by itself on this plan (TRIAL_MCP's
  // Risika for AI trial), so CS sees it before confirming either action.
  const defaultsNote = packageDefaultsNote(plan)

  return (
    <Dialog
      open={open}
      onClose={isSaving ? undefined : onCancel}
      aria-labelledby="apply-defaults-title"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle id="apply-defaults-title">
        {`Apply ${planLabel(plan)} defaults?`}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          This resets every override on this customer to the package defaults
          (rights, counters, countries, score models). Users, zones and Global
          Data subscription dates are kept.
        </DialogContentText>
        {defaultsNote && (
          <DialogContentText sx={{ mt: 2 }} data-testid="package-defaults-note">
            {defaultsNote}
          </DialogContentText>
        )}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onCancel} variant="text">
          Cancel
        </Button>
        <Button onClick={onJustChange} variant="outlined" disabled={isSaving}>
          Just change plan
        </Button>
        <Button onClick={onApply} variant="contained" disabled={isSaving}>
          Apply defaults
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ApplyDefaultsDialog
